import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const permissionsBaseEndpoint = ENDPOINTS.PERMISSIONS;

// Daily Orders API
export const permissionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["permissions"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPermission: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: permissionsBaseEndpoint,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => response,
        providesTags: () => [{ type: "permissions" }],
      }),

      getAllPermissions: builder.query({
        query: (payload) => `${permissionsBaseEndpoint}get-all`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "permissions" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addPermission: builder.mutation({
        query: (requestData) => ({
          url: `${permissionsBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "permissions" }],
      }),
      updatePermission: builder.mutation({
        query: ({id, requestData}) => ({
          url: `${permissionsBaseEndpoint}${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "permissions" }],
      }),
      deletePermission: builder.mutation({
        query: (id) => ({
          url: `${permissionsBaseEndpoint}${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "permissions" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetPermissionQuery,
  useAddPermissionMutation,
  useDeletePermissionMutation,
  useGetAllPermissionsQuery,
  useUpdatePermissionMutation
} = permissionApi;
